import React from 'react';

import { Center, Flex, Paper, Text } from '@mantine/core';
import { IconDots } from '@tabler/icons-react';
import { Branding } from 'components/Branding';
import { useTranslation } from 'react-i18next';

interface AuthConnectionHeaderProps {
  connectionTitle: string;
  connectionAppIcon: React.ReactNode;
  type: 'signIn' | 'signUp';
}

export function AuthConnectionHeader({
  connectionTitle: externalAppTitle,
  connectionAppIcon: externalAppIcon,
  type
}: AuthConnectionHeaderProps) {
  const { t } = useTranslation();

  return (
    <Paper w="100%" p="md">
      <Flex direction="column" w="100%" gap="sm" align="center">
        <Center>
          <Flex direction="row" gap="lg" align="center">
            {externalAppIcon}
            <IconDots color="gray" />
            <Branding avatar width={25} />
          </Flex>
        </Center>
        <Text maw={250} size="md" align="center">
          {type === 'signIn' ? t('AUTH.SIGN_IN_TO_CONNECT') : t('AUTH.SIGN_UP_TO_CONNECT')}
          <Text maw={250} size="md" weight="bold">
            {externalAppTitle}
          </Text>
        </Text>
      </Flex>
    </Paper>
  );
}
